import React, { useState } from 'react';

import { useExport } from './ExportContext';
import { FeatureComponent } from '../articledata/datamanagement/featurecomponents/FeatureComponent';

export const ExportHeaderFieldEditor = ({ headerField }) => {
  const {
    setHeaderFieldValues,
    setHeaderFieldState,
    getHeaderFieldState,
    deleteHeaderFieldValue,
    deleteFromRegExErrorList,
    setRegExErrorList
  } = useExport();

  const [regExError, setRegExError] = useState(false);
  const customFieldEditorData = { storePayloadData: true };

  const headerFieldId = headerField.bmeCatField;
  const hashCode = headerField.keyHashCode;

  let title = headerFieldId;
  let attributes = headerField.bmeCatAttributes;

  let regexRestriction = headerField.regexRestriction;
  let regExErrorMessage = headerField.regExErrorMessage;

  if (regexRestriction) {
    customFieldEditorData.regexRestriction = regexRestriction;
    customFieldEditorData.isRegExError = regExError;
    customFieldEditorData.regexRestrictionMsg = regExErrorMessage;
  }

  let numericMinRestriction = headerField.numericMinRestriction;
  let numericMaxRestriction = headerField.numericMaxRestriction;
  let numericStepRestriction = headerField.numericStepRestriction;

  if (
    numericMinRestriction &&
    numericMaxRestriction &&
    numericStepRestriction &&
    !regexRestriction
  ) {
    customFieldEditorData.numericMinRestriction = numericMinRestriction;
    customFieldEditorData.numericMaxRestriction = numericMaxRestriction;
    customFieldEditorData.numericStepRestriction = numericStepRestriction;
    customFieldEditorData.isRegExError = regExError;
    customFieldEditorData.regexRestrictionMsg = regExErrorMessage;
  }

  if (attributes && Object.keys(attributes).length > 0) {
    title += ' (';
    for (let key in attributes) {
      title += ' ' + key + '=' + attributes[key];
    }
    title += ' )';
  }

  customFieldEditorData.title = title;
  customFieldEditorData.mandatory = headerField.mandatory;

  const featureType = headerField.featureType;

  customFieldEditorData.featureComponent = {};
  customFieldEditorData.featureComponent.featureType = featureType;

  customFieldEditorData.customFieldNotCommonOptions = true;

  let selection = false;
  if (headerField.featureType === 'FEATURE_TYPE_ALPHANUMERIC_SELECTION') {
    selection = true;
  }  
  else if (headerField.featureType === 'FEATURE_TYPE_ALPHANUMERIC_MULTI_SELECTION') {
    selection = true;
    customFieldEditorData.featureComponent.multiSelection = true;
  }

  const value = getHeaderFieldState(hashCode);

  function setValueState(clientStateValue) {
    // if (regexRestriction) {
    //   const regex = new RegExp('^' + regexRestriction + '$');
    //   if (clientStateValue === '' || regex.test(clientStateValue)) {
    //     setHeaderFieldState(hashCode, clientStateValue);
    //   } else {
    //     setError(true);
    //   }
    // } else {
    setHeaderFieldState(hashCode, clientStateValue);
    // }
  }

  function saveCreateValue(newValue, valuePayload) {
    if (newValue) {
      if (regexRestriction) {
        const regex = new RegExp('^' + regexRestriction + '$');
        if (newValue === '' || regex.test(newValue)) {
          setHeaderFieldValues(hashCode, valuePayload);
          setRegExError(false);
          deleteFromRegExErrorList(hashCode);
        } else {
          setRegExErrorList(hashCode);
          setRegExError(true);
        }
      } else if (
        numericMinRestriction &&
        numericMaxRestriction &&
        numericStepRestriction &&
        !regexRestriction
      ) {
        if (
          newValue >= numericMinRestriction &&
          newValue <= numericMaxRestriction &&
          newValue % numericStepRestriction == 0
        ) {
          setHeaderFieldValues(hashCode, valuePayload);
          setRegExError(false);
          deleteFromRegExErrorList(hashCode);
        } else {
          setRegExError(true);
          setRegExErrorList(hashCode);
        }
      } else {
        setHeaderFieldValues(hashCode, valuePayload);
      }
    } else {
      deleteHeaderFieldValue(hashCode);
      setRegExError(false);
      deleteFromRegExErrorList(hashCode);
    }
    if (value?.selected) {
      if (!newValue) {
        newValue = {};
        newValue.customOptions = [];
        newValue.selected = [];
      }
      newValue.standardOptions = value.standardOptions;
    }

    setHeaderFieldState(hashCode, newValue);
  }

  if (!customFieldEditorData || (selection && value == undefined)) {
    return null;
  }
  return (
    <div
      className="custom-field-editor instanceEditorComponent"
      style={{ margin: '2rem 0' }}
    >
      <FeatureComponent
        featureInfo={customFieldEditorData}
        value={value}
        setValueState={setValueState}
        saveChangedValue={saveCreateValue}
        loading={false}
      />
    </div>
  );
};
